import { HttpErrorResponse } from '@angular/common/http';
import { StatusCodeError } from './status-code-error';

export class MessageUtil {
  static toContent(error: string | Error | HttpErrorResponse): MessageContent {
    if (error instanceof Object && error.name === 'HttpErrorResponse') {
      const httpErrorResponse = error as HttpErrorResponse;
      const messages = httpErrorResponse.error?.messages;
      const message =
        messages?.map(({ translation }: { translation: string }) => translation).join('\n') ||
        httpErrorResponse.error?.message;
      const statusCode = httpErrorResponse.status;

      return {
        statusCode,
        message,
        messages: httpErrorResponse.error?.messages,
        exception: httpErrorResponse.error?.exception
      };
    } else if (error instanceof StatusCodeError) {
      return { message: error.message, messages: null, exception: null, statusCode: error.statusCode };
    } else if (error instanceof Error) {
      return { message: error.message, messages: null, exception: null, statusCode: null };
    }
    return { message: error.toString(), messages: null, exception: null, statusCode: null };
  }
}

export interface MessageContent {
  statusCode: number | null;
  message: string;
  messages: { code: string; translation: string }[] | null;
  exception: string | null;
}
